import React, {useContext, useState, createContext, useEffect} from "react";
import { Client } from "../api/axios";
import {useNavigate, useHistory} from 'react-router-dom'
import { useRegisterContext } from "./Register";
import { useAuth } from "./AuthProvider";


const submitUrl = 'https://ciccate2.onrender.com/api/api/exam/submit/'
const Context = createContext({});
const url = 'https://ciccate2.onrender.com/api/api/'
const QuestionUrl = 'https://ciccate2.onrender.com/api/api/exam/start/'


export const AuthLogin = ({children}) => {

  const {setAuth,setAuthData, setAuthId} = useAuth();
  const [alertMessage, setAlertMessage] = useState(null)
  const [questions, setQuestions] = useState([]);
  const Navigate = useNavigate()
  
  const [success, setSuccess] = useState(false)
  
  const Url = 'https://ciccate2.onrender.com/api/api/login/'
  
  const {
    userEmail,
    pwd,
  } = useRegisterContext()
  

  
const [Loading, SetIsLoading] = useState(false)

  const handleLogin = async (e) => {
    SetIsLoading(true)
     e.preventDefault();

     try{
  const response = await Client.post(
    Url, JSON.stringify({
      email:userEmail,
      password:pwd,
    }),
    {
      headers: { 'Content-Type': 'application/json',
     Authorization: 'Bearer ' + localStorage.getItem('access') 
    },
    }
  );
  //console.log(JSON.stringify(response?.data));
  
  
  const access = response?.data?.access;
  const id = response?.data?.id;
  const token = response?.data?.token;
  const refresh = response?.data?.refresh;
  
  localStorage.setItem('accesstoken', access)
  localStorage.setItem('refresh', refresh);
  localStorage.setItem('id', id)

  if (response?.data?.access) {
    localStorage.setItem('user', JSON.stringify(response?.data))
  }

  /*
  setAuth({userEmail,pwd,access,id,token,refresh});
  
  setAuthData(userEmail)
  setAuthId(id);
  */
  setAlertMessage({
    type: 'success',
    message: `Welcome ${userEmail}`,
  })

  setSuccess(true);
  
  
  setTimeout(() => {
    Navigate('/student/student-dashboard')
  }, 2000);
  console.log(success)
  }


  catch(err){
    if (!navigator.onLine) {
      setAlertMessage({
        type: 'error',
        message: 'No internet connection. Please check your device.'
      });
    } else 
    if(err.response){
    const responseData = (err.response.data);
  if( responseData && responseData.detail){
  const errorMessages = Object.values(responseData.detail).flat()
  console.log(errorMessages)
    setAlertMessage({
      type: 'error',
      message: `${errorMessages.join('')} create an account`
    })
  }
  else if(!err.response?.data){
    setAlertMessage({ 
      type:'error',
    message: 'no response from server check your internent'});
  }
  else if(err.response?.status === 401){
  setAlertMessage({
    type:'error',
    message:'user not exist invalid credentials'})

  }
  else {
   setAlertMessage({
    type: 'error',
    message: 'failed to login properly: '
  
   })

  }
  
  }
  
  }
  
  }

 

  const handleLogout = (err) => {
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    localStorage.removeItem('user')
   
    setAlertMessage({
      type:'success',
      message: 'Successfully logged out',
  });

  setTimeout(() => {
    Navigate('/login')
},2000);

  };
  const endAlert = () => {
    setAlertMessage(null);
  };



  const getUser = () => {
return JSON.parse(localStorage.getItem('user'));
  }
 

  const GetExams = (e) => {
  Client.get(url).then((resp) => {
    console.log(resp.data);
    const {message} = resp.data;
    alert(message);
  }).catch((err) => {
    if (err){
      console.log(err);
    }
  });
  };

  useEffect(() => {
    SetIsLoading(false);
  }, [])

  const startExams = (e) => {
    SetIsLoading(true);
    Client.get(QuestionUrl,{
      headers: { 
      Authorization: 'Bearer ' + localStorage.getItem('accesstoken') 
     },
    }).then((resp) => {
      const {questions} = resp.data;
      setQuestions(questions);
      console.log(questions);
      Navigate('/student/information')
     questions.forEach(({id, question, que_type}) => {
        console.log(question);
      })
      
    }).then(()=>{
console.log('success');

    }).catch((err) => {
      if (err){
        console.log(err);
      }
    });
  }

  const submitTest = () => {
    const response = async (req, res) => {
      Client.post(submitUrl,{
     name: 'test'
      }).then(response.data)
      .catch((err) => {
        console.log(err);
      });
    };
  }

    
  return (
   
    <div>
  
      <Context.Provider value={{
        handleLogin,
        Loading,
        SetIsLoading,
        handleLogout,
        setAlertMessage,
        alertMessage,
        GetExams,
        startExams,
        submitTest,
        getUser,
        endAlert}}>
        {children}
      </Context.Provider>
     
    </div>
  )
}

export const useAuthLogin = () => useContext(Context)
